import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { useSessionStore } from "../../store/session-store";

const usePlatformAdmin = () => {
  const { sessionDetails } = useSessionStore();
  const axiosPrivate = useAxiosPrivate();
  return async () => {
    let platformAdmin;
    try {
      const requestOptions = {
        method: "GET",
        url: `/api/v1/get_role`,
        headers: {
          "X-CSRFToken": sessionDetails?.csrfToken,
        },
      };
      const response = await axiosPrivate(requestOptions);
      platformAdmin = response?.data?.is_admin;
    } catch {
      // Silently ignore in case of errors
    }
    return platformAdmin || false;
  };
};

export { usePlatformAdmin };
